import React from "react"
import { Outlet } from "react-router-dom"
import MainLayout from "./MainLayout"

const InsuranceCertificateRoutesMobile = () => {
  return (
    <MainLayout>
      <Outlet />
    </MainLayout>
  )
}

export default InsuranceCertificateRoutesMobile
